<template>
  <div class="container-fluid gallery">
    <h1 class="title text-center">Welcome to Gallery</h1>
    <h4 class="sub-title text-center">Choose a section</h4>
    <div class="row first-row">
      <router-link
        v-for="fun in gallery"
        :key="fun.name"
        :to="fun.path"
        @click.prevent
        class="col-xs-12 col-md-6 col-lg-4"
        :class="fun.class"
      >
        <h1 class="fun-title">{{ fun.name }}</h1>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //gallery: [
      //  { name: 'ANIMATION', path: '/animation', class: 'anime' },
      //  { name: 'GAMES', path: '/games', class: 'games' },
      //  { name: 'AUGMENTED REALITY', path: '/ar', class: 'ar' },
      //  { name: 'WEB DEV', path: '/web-dev', class: 'web-dev' },
      //  { name: 'VIDEO & PHOTO EDITING', path: '/video-photo', class: 'video-photo' },
      //  { name: 'ARDUINO', path: '/arduino', class: 'arduino' },
      //],
      gallery: [
        { name: "ANIMATION", path: "/animation", class: "anime" },
        { name: "VIDEO GAMES", path: "/games", class: "games" },
        { name: "WEB DEVELOPMENT", path: "/web-dev", class: "web-dev" },
        { name: "AUGMENTED REALITY", path: "/ar", class: "ar" },
        {
          name: "VIDEO & PHOTO EDITING",
          path: "/video-photo",
          class: "video-photo",
        },
        { name: "EMBEDDED PROGRAMMING", path: "/embedded", class: "embedded" },
      ],
    };
  },
};
</script>

<style scoped>
.gallery {
  margin-bottom: 80px;
  text-align: center;
}

.title {
  /*margin-bottom: 20px;*/
  color: wheat;
  text-shadow: 0px 0px 2px crimson;
}

.sub-title {
  color: gold;
  text-shadow: 0 0 10px crimson;
}

/*.first-row {
  background: crimson;
}*/

.first-row > a {
  /*
    give it an animation on hover like from movies-vote
  */
  display: flex;
  justify-content: center;
  align-items: center;
  /*border: 1px solid black;*/
  border: 15px solid black;
  border-radius: 50px;
  /*border-image: url(@/assets/gallery/epic-frame.gif) 50;*/
  min-height: 200px;
  height: 40vh;
  text-decoration: none;

  background-size: cover;
  background-position: center;
  /*backdrop-filter: brightness(70%);*/

  transition: all 0.3s ease-in-out;
}

.fun-title {
  color: white;
  text-shadow: 0 0 5px black;
  transition: all 0.2s ease-in-out;
  border-radius: 50px;
}

.first-row > a:hover {
  cursor: pointer;
  border-radius: 20px;
}

.first-row > a:hover .fun-title {
  color: crimson;
  background: rgba(255, 255, 255, 0.7);
  box-shadow: 0 0 10px white;
  /*padding: 10px;*/
  text-shadow: 0 0 3px white;
}

.anime {
  background: url(@/assets/gallery/groundbreak.webp);
}

.games {
  background: url(@/assets/gallery/mc.webp);
}

.web-dev {
  background: url(@/assets/gallery/MM.png);
  background-position: top !important;
}

.ar {
  background: url(@/assets/gallery/ar-ball.webp);
}

.video-photo {
  background: url(@/assets/gallery/templar.png);
}

.embedded {
  background: url(@/assets/gallery/arduino-garage.webp);
}
</style>
